export default {
  'memberSuspension.notice.title': '會員專區',
  'memberSuspension.notice.heading': '會員功能暫停使用',
  'memberSuspension.notice.description': '您的會員功能目前暫停使用，',
  'memberSuspension.notice.contact': '如有疑問請洽門市櫃檯協助。',
  'memberSuspension.notice.provider': '本服務由 Echoss VIP 提供',
  'memberSuspension.register.blocked': '無法註冊，請洽門市。',
  'memberSuspension.login.blocked': '無法登入，請洽門市。',
  'memberSuspension.asset.blocked': '此會員已停用，無法使用優惠或票券。',
  'memberSuspension.feature.blocked': '此會員已停用，無法使用此功能。',
} as Record<string, string>;
